import { clsx } from 'clsx';

export interface ColorCubeProps {
    /** CSS color string for the square's background. */
    color: string;
    /** Side length in pixels. @default 12 */
    size?: number;
    /** Additional className. */
    className?: string;
}

/**
 * A small colored square used as a legend indicator in charts and data tables.
 */
export function ColorCube(props: ColorCubeProps) {
    const { color, size = 12, className } = props;
    return (
        <span
            className={clsx('inline-block shrink-0 rounded-sm', className)}
            style={{ width: size, height: size, backgroundColor: color }}
        />
    );
}
